<template>
  <template v-if="text">
    <!-- Text -->
    <div
      class="bg-black/20 p-3 max-w-4xl mx-auto rounded-xl text-wrapper text-white drop-shadow-md"
      v-html="text.text"
    ></div>
  </template>
  <template v-else>
    <!-- Loader -->
    <TextLoader />
  </template>
</template>

<script>
import TextLoader from "@/components/Loader/TextLoader";
export default {
  name: "TextPlugin",
  components: { TextLoader },
  props: {
    shortcode: String,
  },
  data() {
    return {
      text: null,
    };
  },
  mounted() {
    this.loadText();
  },
  methods: {
    options() {
      return {
        fields: JSON.stringify({ text: 1 }),
        filter: JSON.stringify({ shortcode: this.$props.shortcode }),
      };
    },
    loadText() {
      this.axios
        .get("/api/content/items/text_2", { params: this.options() })
        .then((r) => {
          this.text = r.data[0];
        });
    },
  },
};
</script>

<style scoped>
.text-wrapper:deep(p) {
  @apply mb-4 break-words;
}
.text-wrapper {
  @apply text-center;
}

.text-wrapper:deep(h2) {
  @apply text-xl font-bold;
}
</style>
